// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "4b8bd0d20fc6b26573b881b5c8ea8fcf" + ".css";
};